import { ConnectButton } from "@/components/connect-button";
import {
  TransactionDialog,
  transactionInner,
} from "@/components/transaction/transaction-dialog";
import { getBenchInstanceClient } from "@/lib/clients";
import { N, shorten } from "@/lib/utils";
import { BenchStateFull } from "@myth-finance/bench-sdk";
import { useWallet } from "@txnlab/use-wallet";
import algosdk, { Transaction } from "algosdk";
import { chunk } from "lodash";
import { Wallet, UserRound, ChevronRight } from "lucide-react";

export function DeleteBoxesButton({
  data,
  boxes,
  reloadState,
}: {
  data: BenchStateFull;
  boxes: Uint8Array[];
  reloadState: () => any;
}) {
  const { activeAccount } = useWallet();
  const activeAddress = activeAccount?.address;

  const count = Math.min(128, boxes.length);
  const label =
    boxes.length <= 128
      ? `Delete ${boxes.length} boxes`
      : `Delete 128/${boxes.length} boxes`;

  const makeDeleteBoxTransactions = async () => {
    const boxNamesChunked = chunk(boxes, 8).slice(0, 16);
    const txns = (
      await Promise.all(
        boxNamesChunked.map((boxNames) =>
          getBenchInstanceClient(
            data.appId,
            data.registryAppId
          ).makeDeleteBoxesTxns({
            sender: activeAddress!,
            boxNames,
          })
        )
      )
    ).map(([t]) => Transaction.from_obj_for_encoding(t));
    algosdk.assignGroupID(txns);
    return txns;
  };

  return (
    <TransactionDialog
      type="purchase"
      trigger={(onClick) => (
        <ConnectButton onClick={onClick}>
          <Wallet size={18} className="mr-1.5" />
          <span>{label}</span>
        </ConnectButton>
      )}
      transactionBuilder={() => makeDeleteBoxTransactions()}
      title={`Deleting ${data.sellingUnitName} bench boxes`}
      onClose={() => reloadState()}
      onSuccess={() => reloadState()}
    >
      {transactionInner(
        "operation",
        <>
          You are going to{" "}
          <strong>clean up bench storage ({count} boxes)</strong>
        </>,
        <>
          <div className="flex justify-between gap-2 mb-2">
            <div className="flex items-center">
              <UserRound size={18} className="mr-1" /> Account
            </div>{" "}
            <span>{shorten(activeAddress!)}</span>
          </div>
          {new Array(Math.ceil(count / 8)).fill(1).map((_, i) => (
            <div
              key={`as${i}`}
              className="flex justify-between gap-2 text-foreground"
            >
              <div className="flex items-center">
                <ChevronRight size={18} className="mr-1" /> Call app: delete
                boxes
              </div>
              <span>{N(data.appId)}</span>
            </div>
          ))}
        </>
      )}
    </TransactionDialog>
  );
}
